import React from 'react';
import './NavigationTitle.css';
import { START_TIME } from '../../../../../../constants';

function getDateString(dayId) {
  // todo - repeating function pattern - search for "24 * 60 * 60 * 1000" and put it to one place
  const dayDate = new Date(START_TIME + dayId * 24 * 60 * 60 * 1000);
  return `${dayDate.getDate()}. ${dayDate.getMonth() + 1}.`;
}

function NavigationTitle({ startDayId, columns }) {
  // todo - quick/raw - review
  const dateStart = getDateString(startDayId);
  const dateEnd = getDateString(startDayId + (columns - 1)); // todo - works but review
  const titleString =
    columns === 1 ? `${dateStart} 1968` : `${dateStart} - ${dateEnd} 1968`;

  return <h2 id="head-navigation-title">{titleString}</h2>;
}

export default NavigationTitle;



// WEBPACK FOOTER //
// ./src/components/App/Program/Head/Navigation/NavigationTitle/NavigationTitle.js